module.exports = __webpack_public_path__ + "static/img/case1.bc0a6c7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/customerCase/case1.jpg
// module id = zdbu
// module chunks = 1